var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResAmazonElasticContainerServiceTask48Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Task_48_Light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Resource/Containers/Res_Amazon-Elastic-Container-Service_Task_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,36.375 L36,36.375 L36,34.375 L20.25,34.375 L20.25,36.375 Z M20.25,24.125 L36,24.125 L36,22.125 L20.25,22.125 L20.25,24.125 Z M20.25,11.875 L36,11.875 L36,9.875 L20.25,9.875 L20.25,11.875 Z M13.375,37 L16.625,37 L16.625,33.75 L13.375,33.75 L13.375,37 Z M12.375,39 L17.625,39 C18.178,39 18.625,38.553 18.625,38 L18.625,32.75 C18.625,32.198 18.178,31.75 17.625,31.75 L12.375,31.75 C11.822,31.75 11.375,32.198 11.375,32.75 L11.375,38 C11.375,38.553 11.822,39 12.375,39 L12.375,39 Z M13.375,24.75 L16.625,24.75 L16.625,21.5 L13.375,21.5 L13.375,24.75 Z M12.375,26.75 L17.625,26.75 C18.178,26.75 18.625,26.303 18.625,25.75 L18.625,20.5 C18.625,19.948 18.178,19.5 17.625,19.5 L12.375,19.5 C11.822,19.5 11.375,19.948 11.375,20.5 L11.375,25.75 C11.375,26.303 11.822,26.75 12.375,26.75 L12.375,26.75 Z M13.375,12.5 L16.625,12.5 L16.625,9.25 L13.375,9.25 L13.375,12.5 Z M12.375,14.5 L17.625,14.5 C18.178,14.5 18.625,14.053 18.625,13.5 L18.625,8.25 C18.625,7.698 18.178,7.25 17.625,7.25 L12.375,7.25 C11.822,7.25 11.375,7.698 11.375,8.25 L11.375,13.5 C11.375,14.053 11.822,14.5 12.375,14.5 L12.375,14.5 Z M9,44 L38.5,44 L38.5,4 L9,4 L9,44 Z M39.5,2 L8,2 C7.447,2 7,2.448 7,3 L7,45 C7,45.553 7.447,46 8,46 L39.5,46 C40.053,46 40.5,45.553 40.5,45 L40.5,3 C40.5,2.448 40.053,2 39.5,2 L39.5,2 Z",
    id: "Amazon-Elastic-Container-Service_Task_Resource-Icon_light-bg",
    fill: "#D45B07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResAmazonElasticContainerServiceTask48Light);
export default __webpack_public_path__ + "static/media/Res_Amazon-Elastic-Container-Service_Task_48_Light.291fdc28352bba7d633759ee4ad8e2df.svg";
export { ForwardRef as ReactComponent };